/**
 * RerouteIcon/index.js
 * desc: reroute icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const RerouteIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="reroute icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.reroute.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.7771 4C11.7771 5.06087 11.3953 6.07828 10.7157 6.82843C10.036 7.57857 9.11427 8 8.15315 8C7.19202 8 6.27026 7.57857 5.59064 6.82843C4.91102 6.07828 4.52921 5.06087 4.52921 4C4.52921 2.93913 4.91102 1.92172 5.59064 1.17157C6.27026 0.421427 7.19202 0 8.15315 0C9.11427 0 10.036 0.421427 10.7157 1.17157C11.3953 1.92172 11.7771 2.93913 11.7771 4ZM15.401 14V16H0.905273V14C0.905273 11.79 4.1487 10 8.15315 10C12.1576 10 15.401 11.79 15.401 14ZM18.572 10.5V12H17.213V10.5H18.572ZM16.76 5.5H15.401V5C15.401 4.20435 15.6874 3.44129 16.1971 2.87868C16.7068 2.31607 17.3981 2 18.119 2C18.8398 2 19.5311 2.31607 20.0409 2.87868C20.5506 3.44129 20.8369 4.20435 20.8369 5C20.8369 5.97 20.3839 6.88 19.6682 7.41L19.3964 7.6C18.88 8 18.572 8.61 18.572 9.3V9.5H17.213V9.3C17.213 8.11 17.7566 7 18.6535 6.35L18.9162 6.16C19.2696 5.9 19.4779 5.47 19.4779 5C19.4779 4.60217 19.3348 4.22064 19.0799 3.93934C18.8251 3.65803 18.4794 3.5 18.119 3.5C17.7585 3.5 17.4129 3.65803 17.158 3.93934C16.9032 4.22064 16.76 4.60217 16.76 5V5.5Z" /></svg>
    </IconButton>
);


export default RerouteIcon;
